import React from 'react';
import PostDetailSection from '../../../sections/AdminDashboard/PostManagement/PostDetail';

const PostDetail = () => {
  return <PostDetailSection />;
};

export default PostDetail;


